<template>
  <div class="out_box">
    <!-- HEADER -->
    <div class="box-con">
      <!-- SEARCH CUSTOMER NAME -->
      <div class="header">
        <div class="h-tit">Order list</div>
        <!-- <div style="position: relative">
          <el-input
            type="text"
            class="input-search"
            size="large"
            placeholder="Search Order No"
            clearable
            show-clear
            v-model="searchValOrderNo"
            @clear="orderListEvent"
            @keydown.native.enter="handleEnter"
          />
          <img
            src="../../../assets/img/icon_search.png"
            alt=""
            class="search-icon"
          />
        </div> -->
        <div class="input-search-box">
          <div class="search-input">
            <el-input
              type="text"
              class="input-search"
              size="large"
              placeholder="Search Order No"
              clearable
              show-clear
              v-model="searchValOrderNo"
              @keydown.native.enter="handleEnter"
            />
            <img
              src="../../../assets/img/icon_search.png"
              alt=""
              class="search-icon"
            />
            <div
              class="search-order-list"
              v-if="searchOrderData.length>0"
            >
              <div
                v-for="item in searchOrderData"
                class="list-box"
                :key="item.id"
                @click="searchOrderDetailEvent(item)"
              >
                <div>{{item.no}}</div>
                <div>{{item.trip.vehicleType?item.trip.vehicleType.name:'-'}}</div>
              </div>
            </div>
          </div>
          <div
            class="search-btn"
            @click="searchOrderEvent()"
          >Search</div>
        </div>
      </div>

      <!-- NAV FOR ORDER TYPE -->
      <div class="nav-box">
        <div class="nav-list">
          <div
            :class="{ 'is-active': stateColumn == 'PAID' }"
            @click="handelTripState('PAID')"
          >
            PAID
          </div>
          <div
            :class="{ 'is-active': stateColumn == 'UNPAID' }"
            @click="handelTripState('UNPAID')"
          >
            UNPAID
          </div>
          <div
            :class="{ 'is-active': stateColumn == 'CANCELED' }"
            @click="handelTripState('CANCELED')"
          >
            CANCELLED
          </div>
        </div>
      </div>

      <!-- DATE PICKER -->
      <div class="w100 h50px d_flex d_between">
        <date-picker @dateChange="dateChange" />
      </div>
    </div>

    <!-- TABLE -->
    <div class="outer-table-box">
      <el-table
        :data="tableData"
        height=" calc(100vh - 288px)"
        style="width: 100%"
        fit
      >
        <el-table-column
          prop="orderNo"
          label="Order no."
          width="180"
        >
          <template slot-scope="scope">
            <div
              class="t_underline"
              style="color: #5187e7"
              @click="onOrderDetail(scope.row)"
            >
              {{ scope.row.no }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="orderTime"
          label="Order time"
          width="150"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.orderTime }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="tripType"
          label="Trip type"
          width="100"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.trip.type }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="carType"
          label="Car type"
          width="auto"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.trip.vehicleType && scope.row.trip.vehicleType.name
                  ? scope.row.trip.vehicleType.name
                  : '-'
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="customer"
          label="Customer"
          width="180"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.customer.email }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="totalAmount"
          label="Price"
          width="100"
        >
          <template slot-scope="scope">
            <div>
              MYR {{ scope.row.totalAmount ? scope.row.totalAmount : '-' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="agentEmployee"
          label="Ordered by"
          width="200"
        >
          <template slot-scope="scope">
            <div style="color: #5187e7">{{ scope.row.agentEmployee.name }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="download"
          label=""
          width="70"
        >
          <template slot-scope="scope">
            <div
              @click="onPreview(scope.row)"
              v-if="scope.row.paid && scope.row.state === 'COMPLETED'"
            >
              <el-image
                style="margin-top: 4px; width: 22px; height: 20px"
                :src="require('@/assets/img/icon_download.png')"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- PAGINATION -->
    <div class="paging-box">
      <div class="totality">{{ total }} entries in total</div>
      <el-pagination
        align="center"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- PDFVIEWER -->
    <receipt-previewer
      ref="receiptPreviewer"
      :dialogVisible="prviewDataVisible"
    />

    <!-- ORDERDETAIL -->
    <order-detail
      ref="orderDetail"
      :dialogVisible="orderDataVisible"
    />
  </div>
</template>

<script>
import { getOrderList } from '@/api/orders/orderList'
import datePicker from '@/components/datePicker.vue'
import orderDetail from '@/views/home/orders/orderDetail.vue'
import receiptPreviewer from '@/views/home/orders/receiptPreviewer.vue'

export default {
  components: {
    datePicker,
    orderDetail,
    receiptPreviewer
  },
  data() {
    return {
      searchOrderData: [], //搜索的订单列表
      searchValOrderNo: undefined,
      stateColumn: 'PAID', // PAID, UNPAID, CANCELED
      startDate: {},
      endDate: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      prviewDataVisible: false,
      orderDataVisible: false
    }
  },
  filters: {},
  watch: {
    searchValOrderNo(e) {
      if (e.length >= 0) {
        this.searchOrderData = ''
      }
    }
  },
  created() { },
  mounted() {
    const curDate = this.getCurDate()
    this.startDate = curDate
    this.endDate = curDate
    this.orderListEvent()
  },
  methods: {

    getCurDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const currentDate = `${year}-${month}-${day}`
      return currentDate
    },
    onPreview(row) {
      console.log('onPreview row:', row)
      this.prviewDataVisible = true
      this.$refs.receiptPreviewer.show(row.id)
    },
    searchOrderDetailEvent(e) {
      this.orderDataVisible = true
      this.$refs.orderDetail.show(e.id)
      this.searchOrderData = ''
      this.searchValOrderNo = ''
    },
    onOrderDetail(row) {
      console.log('onOrderDetail row:', row)
      this.orderDataVisible = true
      this.$refs.orderDetail.show(row.id)
    },
    handleEnter(event) {
      if (event.keyCode === 13) {
        this.orderListEvent()
      }
    },
    dateChange(e) {
      console.log('dateChange:', e)
      this.startDate = e
      this.endDate = e
      this.searchValOrderNo = undefined
      this.orderListEvent()
    },
    searchOrderEvent() {
      console.log('搜索🔍');
      let params = {
        no: this.searchValOrderNo,
        size: 10
      }
      getOrderList(params).then((res) => {
        console.log('getOrderList res:', res)
        this.searchOrderData = res.data.results
        if (res.data.results.length <= 0) {
          this.$message('The order was not found!');
        }
      })
    },
    orderListEvent() {
      let paid = undefined
      if (this.stateColumn === 'PAID') {
        paid = true
      } else if (this.stateColumn === 'UNPAID') {
        paid = false
      } else if (this.stateColumn === 'CANCELED') {
        paid = undefined
      }
      let params = {
        startDate: this.startDate,
        endDate: this.endDate,
        number: this.currentPage,
        size: this.pageSize,
        agentOrderTag: this.stateColumn,
        paid: paid,
        // no: this.searchValOrderNo
      }
      // if (this.searchValOrderNo) {
      //   params.agentOrderTag = undefined
      //   params.paid = undefined
      // }
      // console.log('getOrderList params:', params)
      getOrderList(params).then((res) => {
        // console.log('getOrderList res:', res)
        this.tableData = res.data.results
        this.total = res.data.totalElements
        if (this.searchValOrderNo && this.tableData.length === 1) {
          if (
            this.tableData[0].paid === true &&
            this.tableData[0].state === 'COMPLETED'
          ) {
            this.stateColumn = 'PAID'
          } else if (this.tableData[0].state === 'CANCELED') {
            this.stateColumn = 'CANCELED'
          } else if (this.tableData[0].paid === false) {
            this.stateColumn = 'UNPAID'
          }
        }
      })
    },
    handelTripState(val) {
      this.stateColumn = val
      this.searchValOrderNo = undefined
      this.orderListEvent()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.orderListEvent()
    }
  }
}
</script>

<style scoped lang="scss">
.box-con {
  margin-top: 12px;
  box-sizing: border-box;
  padding: 18px 18px 15px 18px;
  background: #fff;
  border-radius: 12px 12px 0px 0px;

  .header {
    display: flex;
    justify-content: space-between;

    ::v-deep .el-input__suffix {
      position: absolute;
      top: -4px;
    }

    .h-tit {
      font-size: 20px;
      font-weight: 500;
      color: #000;
    }

    .input-search-box {
      position: relative;
      display: flex;
      .search-input {
        position: relative;
        .search-order-list {
          position: absolute;
          width: 225px;
          height: 175px;
          overflow: auto;
          background: white;
          border-radius: 6px;
          z-index: 9;
          top: 38px;
          box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05),
            /* 右下方阴影 */ -3px -3px 3px rgba(0, 0, 0, 0.05),
            /* 左上方阴影 */ 3px -3px 3px rgba(0, 0, 0, 0.05),
            /* 右上方阴影 */ -3px 3px 3px rgba(0, 0, 0, 0.05); /* 左下方阴影 */
          scrollbar-width: none !important;
          .list-box {
            width: 201px;
            height: 35px;
            display: flex;
            align-items: center;
            padding: 0 12px;
            justify-content: space-between;
            cursor: pointer;
            div:nth-child(1) {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #000000;
              font-style: normal;
            }
            div:nth-child(2) {
              padding: 0 5px;
              height: 18px;
              background: #eef0f3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              color: #959698;
              font-style: normal;
            }
          }
        }
      }
      .search-btn {
        width: 64px;
        height: 32px;
        background: #ffc649;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        margin-left: 8px;
        cursor: pointer;
      }
    }
    .input-search {
      width: 225px;
      height: 32px;
      background: #fff;
      border: 1px solid #e6e6e6;
      border-radius: 16px;
      overflow: hidden;
      display: flex;
      align-items: center;
    }

    /* 隐藏 el-input 边框 */
    ::v-deep .el-input__inner {
      border: none !important;
      box-shadow: none !important;
      text-indent: 14px !important;
    }

    /* 获取焦点时不显示边框颜色 */
    ::v-deep .el-input__inner:focus {
      border-color: transparent !important;
      box-shadow: none !important;
    }

    .search-icon {
      position: absolute;
      top: 9px;
      left: 9px;
      width: 17px;
      height: 16px;
      cursor: pointer;
    }
  }

  .nav-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    cursor: pointer;
    border-bottom: 1px solid #ededed;

    .nav-list {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      font-weight: 400;

      div {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 80px;
        padding-bottom: 6px;
      }

      div:last-child {
        margin-right: 0;
      }

      .is-active {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        border-bottom: 3px solid #ffc649;
      }
    }
  }
}

.outer-table-box {
  width: 100%;
  overflow: hidden;
  border-radius: 0 0 14px 14px;
  background: #fff;
  height: calc(100vh - 288px);

  ::v-deep .el-table__header-wrapper {
    font-size: 10px !important;
    border-top: 1px solid #ededed !important;
  }

  ::v-deep .el-table__body-wrapper {
    font-size: 12px !important;
  }

  ::v-deep .el-table__body td {
    padding: 9.9px 0 !important;
    color: black !important;
  }

  ::v-deep .el-table th.el-table__cell {
    background: #fcfcfc !important;
    color: #000 !important;
  }

  ::v-deep .el-pagination.is-background .el-pager li {
    border: 1px solid #eaeaea !important;
  }
}

.paging-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
  height: 34px;

  .totality {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #a0a0a0;
    line-height: 17px;
    text-align: left;
    font-style: normal;
  }

  ::v-deep .el-pagination {
  }

  ::v-deep .el-pager li,
  ::v-deep .btn-next,
  ::v-deep .btn-prev {
    border: 1px solid #eaeaea !important;
    background: #fff !important;
    border-radius: 4px;
    min-width: 28px !important;
    padding: 0px !important;
    margin-left: 4px;
  }

  ::v-deep .el-pager .active {
    text-decoration-line: underline !important;
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: transparent !important;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    border-radius: 4px;
    color: #5187e7;
    text-align: center;
    font-style: normal;
    background: #fff !important;
  }
}
</style>
